import useGlobalMessages from './globalMessages'
import useCustomMessages from './customMessages'
import { createMessage } from '../socket/createMessage'

export class sendMessages {
  constructor(socket) {
    this.socket = socket
    this.stellarSocketMessages = useCustomMessages(this.sendSocketMessage)
    this.globalSocketMessages = useGlobalMessages(this.sendSocketMessage)
  }
  sendSocketMessage = (...args) => {
    const message = createMessage(...args)
    this.socket.current.sendMessage(message)
  }
}
